import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { useLocation } from 'react-router';
import { Badge, Box, Typography } from '@mui/material';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import ContactChatListItem from 'src/views/management/ChatView/ChatSidebar/styled/ContactChatListItem';
import { getLastMessageInfo, getLastMessageTime } from 'src/views/management/ChatView/ChatSidebar/ChatList/ChatItem';
import { SHORT_CODES_PATH } from 'src/views/management/ChatView/ShortCodes/shortCodePaths';

/**
 * CON-2014 — the one "Short codes" row in the Connections list, placed by its
 * latest text's time (CON-2034, shortCodePlacement.js). Every text from a 5-6
 * digit short code is read under it, one thread per code.
 */
function ShortCodesChatItem({ onClick = () => { } }) {
  const location = useLocation();
  const { shortCodes, totalUnreadCount } = useSelector((state) => state?.shortCodes || {});
  const latest = shortCodes?.[0];
  const isActive = location.pathname.startsWith(SHORT_CODES_PATH);

  return (
    <div data-chat-key="short-codes">
      <ContactChatListItem
        component={RouterLink}
        to={SHORT_CODES_PATH}
        active={isActive}
        onClick={onClick}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'center',
            marginBottom: '6px',
          }}
        >
          <Box sx={{
            display: 'flex', alignItems: 'center', gap: '6px', overflow: 'hidden'
          }}
          >
            <SmsOutlinedIcon sx={{ fontSize: '18px', color: '#546E7A', flexShrink: 0 }} />
            <Typography variant="h5" color="textPrimary">
              Short codes
            </Typography>
          </Box>
          <Typography variant="caption" color="textSecondary" sx={{ flexShrink: 0 }}>
            {latest?.latestReceivedAt ? getLastMessageTime(latest.latestReceivedAt) : ''}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            minHeight: totalUnreadCount ? '20px' : 0,
            width: '100%',
          }}
        >
          <Typography
            variant="body2"
            sx={{ textOverflow: 'ellipsis', color: '#546E7A', paddingRight: '4px' }}
            noWrap
          >
            {latest ? `${latest.code}: ` : ''}
            {latest ? getLastMessageInfo(latest.lastMessage) : ''}
          </Typography>
          <Badge
            badgeContent={totalUnreadCount}
            invisible={!totalUnreadCount}
            color="secondary"
            sx={{
              marginLeft: '30px',
              '& .MuiBadge-badge': {
                right: 10,
                top: 10,
              },
            }}
          />
        </Box>
      </ContactChatListItem>
    </div>
  );
}

ShortCodesChatItem.propTypes = {
  onClick: PropTypes.func,
};

export default ShortCodesChatItem;
